module.exports = __webpack_public_path__ + "img/1-zzgc.fd3d78d0.jpg";